import dayjs from 'dayjs'

const capitalize = (s) => {  if (typeof s !== 'string') return ''
  return s.charAt(0).toUpperCase() + s.slice(1)
}

// The server's fullAddress ends in the country, and every object here is in
// Estonia, so on screen it is only noise. Another country is left standing.
const shortAddress = (s) => {
  if (typeof s !== 'string') return s
  return s.replace(/,\s*Estonia\s*$/i, '')
}

// A date range the Estonian way: "21.–25. sept 2026", "29. sept – 2. okt 2026",
// "29. dets 2026 – 2. jaan 2027", or one day on its own.
const dateRange = (start, end) => {
  const a = dayjs(start)
  const b = dayjs(end)
  if (!a.isValid()) return ''
  if (!b.isValid() || a.isSame(b, 'day')) return a.format('D. MMM YYYY')
  if (a.isSame(b, 'month')) return a.format('D.') + '–' + b.format('D. MMM YYYY')
  if (a.isSame(b, 'year')) return a.format('D. MMM') + ' – ' + b.format('D. MMM YYYY')
  return a.format('D. MMM YYYY') + ' – ' + b.format('D. MMM YYYY')
}

// A maintenance entry's text, pulled apart the way the printed hooldusakt does
// it (server/service/hooldusaktPdf.js parseDescription; customer3 has the same
// helper): every <i> is one step, its stored "N." dropped because the list
// numbers itself; whatever is left, minus the bold headings, is the comment.
const stripTags = (value) => String(value)
  .replace(/\\n/g, '\n')
  .replace(/<br\s*\/?>/gi, '\n')
  .replace(/<\/p>/gi, '\n')
  .replace(/<[^>]*>/g, '')
  .replace(/&nbsp;/gi, ' ')
  .replace(/&amp;/gi, '&')
  .replace(/&lt;/gi, '<')
  .replace(/&gt;/gi, '>')
  .replace(/&quot;/gi, '"')
  .replace(/&#39;/gi, "'")
const parseDescription = (description) => {
  const raw = description == null ? '' : String(description)
  const italic = /<i>([\s\S]*?)<\/i>/gi
  const works = []
  let match
  while ((match = italic.exec(raw)) !== null) {
    const text = stripTags(match[1]).replace(/^\s*\d+\s*\.\s*/, '').replace(/\s+/g, ' ').trim()
    if (text) works.push(text)
  }
  const rest = raw.replace(italic, '').replace(/<b[^>]*>[\s\S]*?<\/b>/gi, '\n')
  const comment = stripTags(rest).split('\n').map(line => line.trim()).filter(Boolean).join('\n')
  return { comment, works }
}

export { capitalize, shortAddress, dateRange, parseDescription }
